import React, { useState } from "react";
import { connect } from "react-redux";
import "../assets/css/authentication/form-2.css";
import { agentSignup } from "../store/Admin/admin.action";
import logo from "../assets/img/logo.png";
import { projectName } from "../util/config";

const AgentRegistration = (props) => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState({});

  const isEmail = (value) => {
    return /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/.test(value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    let errorObj = {};
    if (!name) errorObj.name = "Name is required!";
    if (!email) errorObj.email = "Email is required!";
    else if (!isEmail(email)) errorObj.email = "Invalid Email!";
    if (!password) errorObj.password = "Password is required!";
    if (password !== confirmPassword) errorObj.confirmPassword = "Passwords do not match!";

    if (Object.keys(errorObj).length > 0) {
      setError(errorObj);
      return;
    }

    const data = { name, email, password };
    props.agentSignup(data);
  };

  return (
    <div className="form-container outer" style={{ backgroundColor: "#eef2f6" }}>
      <div className="form-form">
        <div className="form-form-wrap">
          <div className="form-container">
            <div className="form-content" style={{ backgroundColor: "#ffffff", padding: "40px", borderRadius: "20px" }}>
              <img
                src={logo}
                style={{ width: "100px", height: "100px", borderRadius: "20px", marginBottom: "20px" }}
                alt="Logo"
              />
              <h3 style={{ fontWeight: "bold", color: "#87CEEB" }}>Agent Registration</h3>
              <p style={{ color: "#000" }}>Register as an agent for {projectName}</p>
              
              <form onSubmit={handleSubmit} className="text-left">
                <div className="form">
                  <div className="form-group mb-3">
                    <label>Name</label>
                    <input
                      type="text"
                      className="form-control"
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                      placeholder="Enter Full Name"
                      style={{ borderRadius: "12px" }}
                    />
                    {error.name && <small className="text-danger">{error.name}</small>}
                  </div>

                  <div className="form-group mb-3">
                    <label>Email</label>
                    <input
                      type="email"
                      className="form-control"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      placeholder="Enter Email"
                      style={{ borderRadius: "12px" }}
                    />
                    {error.email && <small className="text-danger">{error.email}</small>}
                  </div>

                  <div className="form-group mb-3">
                    <label>Password</label>
                    <input
                      type="password"
                      className="form-control"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      placeholder="Enter Password"
                      style={{ borderRadius: "12px" }}
                    />
                    {error.password && <small className="text-danger">{error.password}</small>}
                  </div>

                  <div className="form-group mb-3">
                    <label>Confirm Password</label>
                    <input
                      type="password"
                      className="form-control"
                      value={confirmPassword}
                      onChange={(e) => setConfirmPassword(e.target.value)}
                      placeholder="Confirm Password"
                      style={{ borderRadius: "12px" }}
                    />
                    {error.confirmPassword && <small className="text-danger">{error.confirmPassword}</small>}
                  </div>

                  <div className="d-sm-flex justify-content-between mt-4">
                    <button type="submit" className="btn text-white" style={{ background: "#87CEEB", borderRadius: "12px", width: "100%" }}>
                      Register
                    </button>
                  </div>
                  
                  <div className="mt-4 text-center">
                    <p>Looking for the Android App? <a href="https://api.alivedream.in/storage/apk/alivedream_v52.apk" style={{ color: "#87CEEB", fontWeight: "bold" }}>Download Alive Dream v52 APK</a></p>
                  </div>

                  <div className="mt-3 text-center">
                    <p>Already have an account? <a href="/loginAdmin" style={{ color: "#87CEEB" }}>Login</a></p>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default connect(null, { agentSignup })(AgentRegistration);
